const formatTestId = (value, prefix = '') =>
  value ? `${prefix}${value.replace(/\s+/g, '-').toLowerCase()}` : '';

export default formatTestId;
